import { createAction, props } from '@ngrx/store';
import { GeoJSON } from '../../models/geojson';
import { MapMode } from '../../services/location-map.service';
import { LocationType } from '../../services/location.service';
import { LocationInterface } from '../../models/location-interface';
import { LocationOptions } from '@fc-locations/models/location-options';

export const loadLocationTypes = createAction(
  '[Locations] Load Location Types',
);

export const selectLocationTypeFilter = createAction(
  '[Locations] Set location type filter',
  props<{ locationType: LocationType }>(),
);
export const updateTypeSuccess = createAction(
  '[Locations] Update  type success',
  props<{ locationType: LocationType }>(),
);

export const updateType = createAction(
  '[Locations] Update type',
  props<{ locationType: LocationType }>(),
);

export const addNewType = createAction(
  '[Locations] Add new type',
  props<{ locationType: LocationType }>(),
);
export const deleteType = createAction(
  '[Locations] Delete type',
  props<{ locationType: LocationType }>(),
);
export const deleteTypeSuccess = createAction(
  '[Locations] Delete type success',
  props<{ locationType: LocationType }>(),
);
export const updateLocation = createAction(
  '[Locations] Update Location',
  props<{ location: LocationInterface }>(),
);

export const addNewTypeSuccess = createAction(
  '[Locations] Add new type success',
  props<{ locationType: LocationType }>(),
);

export const eventSourceLocationUpdate = createAction(
  '[Locations] EventSource Location Update',
  props<{ locations: LocationInterface[] }>(),
);

export const updateLocationSuccess = createAction(
  '[Locations] Update Location Success',
  props<{ location: LocationInterface }>(),
);

export const loadLocationTypesSuccess = createAction(
  '[Locations] Load Location Types Success',
  props<{ locationTypes: LocationType[] }>(),
);

export const setMapMode = createAction(
  '[Locations] Set Map Mode',
  props<{ mapMode: MapMode }>(),
);

export const selectFeature = createAction(
  '[Locations] Select Feature',
  props<{ locationFeature: GeoJSON | null }>(),
);

export const getLocations = createAction(
  '[Locations] Get Locations',
  props<{ bbox?: number[]; fields?: LocationOptions[] }>(),
);

export const getLocationsSuccess = createAction(
  '[Locations] Get Locations Success',
  props<{ data: { locationList: LocationInterface[]; count: number } }>(),
);

export const updateLocations = createAction(
  '[Locations] Update Locations',
  props<{ update: { locationList: LocationInterface[]; count: number } }>(),
);

export const saveFeature = createAction(
  '[Locations] Save Feature',
  props<{ location: LocationInterface }>(),
);

export const saveFeatureSuccess = createAction(
  '[Locations] Save Feature Success',
  props<{ location: LocationInterface }>(),
);

export const mapError = createAction(
  '[Locations] Map error',
  props<{ error: any }>(),
);

export const deleteLocation = createAction(
  '[Locations] Delete Location',

  props<{ location: LocationInterface }>(),
);

export const deleteLocationSuccess = createAction(
  '[Locations] Delete Location Success',

  props<{ location: LocationInterface }>(),
);
